import React from 'react';
import { Grid } from '@mui/material';
import './About.css';


export function About() {

    const downloadCV = () => {
        fetch(process.env.PUBLIC_URL + "/cv.pdf").then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = "cv.pdf";
                alink.click();
            })
        })
    }

    return (
        <section id="about">
            <div id="about-text">
                <h1>Hello, World!</h1>
                <p>I am Giovanni and I am software developer from Canary Islands. I have been a tech freak since I was a kid and had my first computer.
                    That made me study Computer Science and become the person I am now: A professional with more than 4 years of experience, curious about
                    new technologies and willing to learn them, but also with strong knowledge of several ones.</p>

                <p>In those 4 years, I have focused on Backend Development with Python and PHP and a little bit less on Frontend Development with Vue. 
                    But, as someone resilient that easily adapts and learns new stuff, I have been given the responsibility to do other several things even though
                    I "just" have 4 years of experience: project management, mentoring people, server configuration, production deployments, database management,
                    project architecture, etc.</p>

                <p>To resume, I am someone in whom you can trust to build your project the best way I know, but also that will keep learning better ways.</p>

                <p>If you want to know more about me, don't hesitate to <strong><a href="#contact">contact</a></strong> me and download my CV here:</p>

                <button id="submit" onClick={downloadCV}>Download CV</button>
            </div>
            <div id="about-img">
                <img src={process.env.PUBLIC_URL + "/images/cv.jpg"} alt="Profile pic" />
            </div>
        </section>
    )
}